import { atom } from 'jotai';

import {
  type Listing,
  type ListingGeoLocation,
} from '@/features/listing/types/listing-types';

interface ListingMapHighlight {
  coordinates: ListingGeoLocation;
  id: Listing['id'];
}

export const listingMapHighlightAtom = atom<ListingMapHighlight | null>(null);
